export const environment = {
  name: 'dev',
  production: false,
  API_URL: 'https://api.dev.eprimerx.com/private_gateway/api/',
  AZURE_REDIRECT_URL: 'https://azurerelayui.dev.eprimerx.com'
};
